import React, { useState } from 'react';
import { supabase } from '../supabaseClient';
import { useNavigate } from 'react-router-dom';
import './SignupPage.css'; // You can reuse SignupPage.css if you want

const LoginPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleChange = (e) => {
    setFormData({ 
      ...formData, 
      [e.target.name]: e.target.value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setMessageType('');

    const { error } = await supabase.auth.signInWithPassword({
      email: formData.email,
      password: formData.password,
    });

    if (error) {
      setMessage('Login failed: ' + error.message);
      setMessageType('error');
      return;
    }

    setMessage('Login successful! Redirecting...');
    setMessageType('success');
    navigate('/dashboard', { replace: true });
  };

  const handleForgotPassword = async () => {
    if (!formData.email) {
      setMessage('Please enter your email to reset your password.');
      setMessageType('error');
      return;
    }

    const { error } = await supabase.auth.resetPasswordForEmail(formData.email, {
      redirectTo: `${window.location.origin}/reset-password`,
    });

    if (error) {
      setMessage('Reset failed: ' + error.message);
      setMessageType('error');
    } else {
      setMessage('Password reset email sent!');
      setMessageType('success');
    }
  };

  return (
    <div className="signup-page">
      <h2>Login</h2>

      {message && (
        <div className={`popup-message ${messageType}`}>
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          required
          onChange={handleChange}
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          required
          onChange={handleChange}
        />
        <button type="submit">Log In</button>

        <p className="forgot-link" onClick={handleForgotPassword} style={{ cursor: 'pointer', color: '#711921' }}>
          Forgot password?
        </p>
        <p className="forgot-link" style={{ fontSize: '0.9em', color: '#711921' }}>
          Forgot email? Contact the tournament organizer.
        </p>
      </form>

    </div>
  );
};

export default LoginPage;
